import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';
import { BaseAgency, ENTITLEMENTS, EntitlementsHelperService, LINE_OF_BUSINESS_ENUM, LoggedInUserInformationService, LOGIN_INFO_REDUCER_NAME, SeniorAgency, UserInfo, UserInfoStateStructure } from '@ptl/account-management';
import { ReducerUtilityService, REDUCER_TYPES } from '@ptl/state';
import { LineOfBusiness } from '../interfaces/lob.interface';
import { AuthoringModeService } from 'src/app/shared/services/authoring-mode.service';
import { environment } from 'src/environments/environment';
import { UserInfoService } from '../../shared/services/user-info.service';
import { BooleanInput, GlobalShadowStyleDirective } from '@ptl/global-components';

const VARIABLE_PREFIX = {
  DSNP: 'dsnp',
  EGWP: 'egwp',
  MEDICARE: 'medicare',
  INDIVIDUAL: 'individual',
  SMALL_GROUP: 'smallGroup',
  GROUP_AGENCY: 'groupAgency',
  CONNECTURE: 'connectureMedicare',
  CONNECTURE_DSNP: 'connectureDsnp',
};

@Component({
    selector: 'app-producer-lines-of-business',
    templateUrl: './producer-lines-of-business.component.html',
    styleUrls: ['./producer-lines-of-business.component.scss'],
    encapsulation: ViewEncapsulation.ShadowDom,
    standalone: false
})
export class ProducerLinesOfBusinessComponent extends GlobalShadowStyleDirective implements OnInit {

  // TODO - Convert buttons to dynamic lists in AEM  - AND - use entitlements to drive logic
  // This may require a redesign of the dashboard as it implies any number of buttons can be added,
  // but the CSS/HTML is designed specifically for 3 buttons.

  @Input() @BooleanInput() dsnpForceHideCard: boolean;
  @Input() @BooleanInput() dsnpShowRegionFilter: boolean;
  @Input() dsnpCardLabel: string = 'DSNP';
  @Input() dsnpPrimaryButtonLabel: string;
  @Input() dsnpPrimaryButtonUrl: string;
  @Input() dsnpSecondaryButtonLabel1: string;
  @Input() dsnpSecondaryButtonUrl1: string;
  @Input() dsnpSecondaryButtonLabel2: string;
  @Input() dsnpSecondaryButtonUrl2: string;

  @Input() @BooleanInput() egwpForceHideCard: boolean;
  @Input() @BooleanInput() egwpShowRegionFilter: boolean;
  @Input() egwpCardLabel: string = 'Medicare Employer Group';
  @Input() egwpPrimaryButtonLabel: string;
  @Input() egwpPrimaryButtonUrl: string;
  @Input() egwpSecondaryButtonLabel1: string;
  @Input() egwpSecondaryButtonUrl1: string;
  @Input() egwpSecondaryButtonLabel2: string;
  @Input() egwpSecondaryButtonUrl2: string;

  @Input() @BooleanInput() medicareForceHideCard: boolean;
  @Input() @BooleanInput() medicareShowRegionFilter: boolean;
  @Input() medicareCardLabel: string = 'Medicare';
  @Input() medicarePrimaryButtonLabel: string;
  @Input() medicarePrimaryButtonUrl: string;
  @Input() medicareSecondaryButtonLabel1: string;
  @Input() medicareSecondaryButtonUrl1: string;
  @Input() medicareSecondaryButtonLabel2: string;
  @Input() medicareSecondaryButtonUrl2: string;

  @Input() @BooleanInput() individualForceHideCard: boolean;
  @Input() @BooleanInput() individualShowRegionFilter: boolean;
  @Input() individualCardLabel: string = 'Individual';
  @Input() individualPrimaryButtonLabel: string;
  @Input() individualPrimaryButtonUrl: string;
  @Input() individualSecondaryButtonLabel1: string;
  @Input() individualSecondaryButtonUrl1: string;
  @Input() individualSecondaryButtonLabel2: string;
  @Input() individualSecondaryButtonUrl2: string;

  @Input() @BooleanInput() smallGroupForceHideCard: boolean;
  @Input() @BooleanInput() smallGroupShowRegionFilter: boolean;
  @Input() smallGroupCardLabel: string = 'Small Group';
  @Input() smallGroupPrimaryButtonLabel: string;
  @Input() smallGroupPrimaryButtonUrl: string;
  @Input() smallGroupSecondaryButtonLabel1: string;
  @Input() smallGroupSecondaryButtonUrl1: string;
  @Input() smallGroupSecondaryButtonLabel2: string;
  @Input() smallGroupSecondaryButtonUrl2: string;

  @Input() @BooleanInput() groupAgencyShowRegionFilter: boolean;
  @Input() @BooleanInput() groupAgencyForceHideCard: boolean;
  @Input() @BooleanInput() shouldShowGroupAgency: boolean;
  @Input() groupAgencyCardLabel: string = 'Direct Links';
  @Input() groupAgencyPrimaryButtonLabel: string;
  @Input() groupAgencyPrimaryButtonUrl: string;
  @Input() groupAgencySecondaryButtonLabel1: string;
  @Input() groupAgencySecondaryButtonUrl1: string;
  @Input() groupAgencySecondaryButtonLabel2: string;
  @Input() groupAgencySecondaryButtonUrl2: string;

  @Input() @BooleanInput() connectureForceHideCard: boolean;
  @Input() @BooleanInput() connectureShowRegionFilter: boolean;
  @Input() connectureMedicareCardLabel: string = 'Medicare';
  @Input() connectureMedicarePrimaryButtonLabel: string;
  @Input() connectureMedicarePrimaryButtonSsoType: string;
  @Input() connectureMedicarePrimaryButtonUrl: string;
  @Input() connectureMedicareSecondaryButtonLabel1: string;
  @Input() connectureMedicareSecondaryButtonSsoType1: string;
  @Input() connectureMedicareSecondaryButtonUrl1: string;
  @Input() connectureMedicareSecondaryButtonLabel2: string;
  @Input() connectureMedicareSecondaryButtonSsoType2: string;
  @Input() connectureMedicareSecondaryButtonUrl2: string;

  @Input() @BooleanInput() connectureDsnpForceHideCard: boolean;
  @Input() @BooleanInput() connectureDsnpShowRegionFilter: boolean;
  @Input() connectureDsnpCardLabel: string = 'DSNP';
  @Input() connectureDsnpPrimaryButtonLabel: string;
  @Input() connectureDsnpPrimaryButtonSsoType: string;
  @Input() connectureDsnpPrimaryButtonUrl: string;
  @Input() connectureDsnpSecondaryButtonLabel1: string;
  @Input() connectureDsnpSecondaryButtonSsoType1: string;
  @Input() connectureDsnpSecondaryButtonUrl1: string;
  @Input() connectureDsnpSecondaryButtonLabel2: string;
  @Input() connectureDsnpSecondaryButtonSsoType2: string;
  @Input() connectureDsnpSecondaryButtonUrl2: string;

  lobs: LineOfBusiness[] = [];
  hasCheckedTempPassword: boolean;
  isLoading: boolean = true;

  constructor(
    private reducerUtilityService: ReducerUtilityService,
    private entitlementHelper: EntitlementsHelperService,
    private authoringMode: AuthoringModeService,
    private userInfoService: UserInfoService
  ) { 
    super();
  }

  ngOnInit() {
    this.userInfoService.isLoggedIn$.subscribe((isLoggedIn: boolean) => {
      if (isLoggedIn) {
        this.populateLinesOfBusiness();
        this.isLoading = false;
      }
    });
  }

  populateLinesOfBusiness() {
    this.lobs = [];
    const userInfoState: UserInfoStateStructure = this.reducerUtilityService.getGlobalStateItem(`${REDUCER_TYPES.APPLICATION_STATE}.${LOGIN_INFO_REDUCER_NAME}`);
    const userInfo = userInfoState.userInfo;

    this.showMedicareCard(userInfo);
    this.showMedicareConnectureCard(userInfo);
    this.showIndividualCard(userInfo);
    this.showSmallGroupCard(userInfo);

    // TODO: We need a better way to configure the tiles by which entitlements are required to see that tile.
    // Don't click on "showShowGroupAgency" for MN or you will get a duplicate, logic to be improved later.
    // Reusing groupagency config to config the Benefits manager block because this is going away eventually.
    this.showMNEmployerPortal(userInfo);

    this.showProducerSupportCard(userInfo);
    this.showDSNPCard(userInfo);
    this.showDSNPConnectureCard(userInfo);
    this.showEGWPCard(userInfo);
  }

  canShowLineOfBusiness(useUnlicensedAgencies: boolean, unlicensedAgencies, licensedAgencies?:BaseAgency[]): boolean {
    if (this.authoringMode.getAuthoringMode() || 
        (useUnlicensedAgencies && unlicensedAgencies?.length > 0) ||
        (!useUnlicensedAgencies && licensedAgencies?.length > 0)) {
      return true;
    } 
    else {
      return false;
    }
  }

  hasPlanAdvisorEntitlements() {
    const hasPav1 = this.entitlementHelper.entitlementValueByNameAndLob(ENTITLEMENTS.RENEWALS, LINE_OF_BUSINESS_ENUM.SMALL_GROUP);
    const hasPav2 = this.entitlementHelper.entitlementValueByNameAndLob(ENTITLEMENTS.SMALL_GRP_QUOTES, LINE_OF_BUSINESS_ENUM.SMALL_GROUP);

    return hasPav1 || hasPav2;
  }

  goToUrl(url: string) {
    window.location.href = url;
  }

  editAgency(editLob: LineOfBusiness) {
    // Only allowing one edit at a time keeps the experience cleaner
    this.lobs.forEach(lob => lob.agencyEditMode = false);

    editLob.agencyEditMode = true;
  }

  agencyChange(newAgency: BaseAgency, lob: LineOfBusiness) {
    lob.agencyEditMode = false;

    // Refresh the cards on any change
    this.populateLinesOfBusiness();
  }

  // Medicare
  showMedicareCard(userInfo: UserInfo) {
    if (!this.medicareForceHideCard && this.canShowLineOfBusiness(this.medicareShowRegionFilter, userInfo.agencies, userInfo.broker360Agencies)) {
      this.addLobEntry(userInfo, VARIABLE_PREFIX.MEDICARE, LINE_OF_BUSINESS_ENUM.SENIOR);
    }
  }

  // Check connecture permissions with Medicare Agencies and market
  showMedicareConnectureCard(userInfo: UserInfo) {
    if (!this.connectureForceHideCard && this.canShowLineOfBusiness(this.connectureShowRegionFilter, userInfo.agencies, userInfo.broker360Agencies)) {
      this.addLobEntry(userInfo,  VARIABLE_PREFIX.CONNECTURE, LINE_OF_BUSINESS_ENUM.SENIOR);
    }
  }

  // Individual
  showIndividualCard(userInfo: UserInfo) {
    if (!this.individualForceHideCard && this.canShowLineOfBusiness(this.individualShowRegionFilter, userInfo.agencies, userInfo.broker360ACAAgencies)) {
      this.addLobEntry(userInfo, VARIABLE_PREFIX.INDIVIDUAL, LINE_OF_BUSINESS_ENUM.INDIVIDUAL);
    }
  }

  // Small Group
  showSmallGroupCard(userInfo: UserInfo) {
    if (!this.smallGroupForceHideCard && this.canShowLineOfBusiness(this.smallGroupShowRegionFilter, userInfo.agencies) && this.hasPlanAdvisorEntitlements()) {
      this.addLobEntry(userInfo, VARIABLE_PREFIX.SMALL_GROUP, LINE_OF_BUSINESS_ENUM.SMALL_GROUP);
    }
  }

  showMNEmployerPortal(userInfo: UserInfo) {
    const hasClientAdmin = this.entitlementHelper.entitlementValueByNameAndLob(ENTITLEMENTS.CLIENT_ADMIN, LINE_OF_BUSINESS_ENUM.SMALL_GROUP);
    
    // TODO: This can be deleted after Benefits Manager SSO is removed and replaced with a link around end of 2022.
    if (!this.groupAgencyForceHideCard
        && environment.initData.brand.ASPID === 'MN'
        && this.canShowLineOfBusiness(this.groupAgencyShowRegionFilter, userInfo.agencies)
        && hasClientAdmin) {
      this.addLobEntry(userInfo, VARIABLE_PREFIX.GROUP_AGENCY, LINE_OF_BUSINESS_ENUM.SMALL_GROUP);
    }
  }

  // Producer Support
  showProducerSupportCard(userInfo: UserInfo) {
    if (!this.groupAgencyForceHideCard && this.shouldShowGroupAgency && this.canShowLineOfBusiness(this.groupAgencyShowRegionFilter, userInfo.agencies)) {
      this.addLobEntry(userInfo, VARIABLE_PREFIX.GROUP_AGENCY, LINE_OF_BUSINESS_ENUM.SMALL_GROUP);
    }
  }

  // DSNP
  showDSNPCard(userInfo: UserInfo) {
    if (!this.dsnpForceHideCard && this.canShowLineOfBusiness(this.dsnpShowRegionFilter, userInfo.agencies, userInfo.broker360DSNPAgencies)) {
      this.addLobEntry(userInfo, VARIABLE_PREFIX.DSNP, LINE_OF_BUSINESS_ENUM.DSNP);
    }
  }

  // Check connecture permissions with DSNP Agencies and market
  showDSNPConnectureCard(userInfo: UserInfo) {
    if (!this.connectureDsnpForceHideCard && this.canShowLineOfBusiness(this.connectureDsnpShowRegionFilter, userInfo.agencies, userInfo.broker360DSNPAgencies)) {
      this.addLobEntry(userInfo, VARIABLE_PREFIX.CONNECTURE_DSNP, LINE_OF_BUSINESS_ENUM.DSNP);
    }
  }

  // EGWP
  showEGWPCard(userInfo: UserInfo) {
    if (!this.egwpForceHideCard && this.canShowLineOfBusiness(this.egwpShowRegionFilter, userInfo.agencies, userInfo.broker360EGWPAgencies)) {
      this.addLobEntry(userInfo, VARIABLE_PREFIX.EGWP, LINE_OF_BUSINESS_ENUM.EGWP);
    }
  }

  addLobEntry(userInfo: UserInfo, configKey: string, lob: LINE_OF_BUSINESS_ENUM) {
    this.lobs.push({
      title: this[configKey+'CardLabel'],
      market: lob,
      showRegionFilter: this[configKey+'ShowRegionFilter'],
      selectedRegion: userInfo?.agencyInfo.selectedAgencies[lob].region,
      selectedAgency: userInfo?.agencyInfo.selectedAgencies[lob].agencyName,
      selectedAgencyId: userInfo?.agencyInfo.selectedAgencies[lob].agencyId,
      primaryLabel: this[configKey+'PrimaryButtonLabel'],
      primaryUrl: this[configKey+'PrimaryButtonUrl'],
      ssoType: this[configKey + 'PrimaryButtonSsoType'],
      secondaryButtons: [{
        ssoType: this[configKey + 'SecondaryButtonSsoType1'],
        label: this[configKey+'SecondaryButtonLabel1'],
        url: this[configKey+'SecondaryButtonUrl1']
      },
      {
        ssoType: this[configKey + 'SecondaryButtonSsoType2'],
        label: this[configKey+'SecondaryButtonLabel2'],
        url: this[configKey+'SecondaryButtonUrl2']
      }]
    });
  }
}
